import React, { useEffect, useRef, useState } from "react";
import { AirbudsYearlyHeader } from "./component/storyHeader";
import { TypeAnimation } from "react-type-animation";

import { motion, animate } from "motion/react";

import { useNavigate } from "react-router";

function useStateAndRef(initial) {
  const [value, setValue] = useState(initial);
  const valueRef = useRef(value);
  valueRef.current = value;
  return [value, setValue, valueRef];
}

export const ComebackMessage = ({ featureText, next }) => {
  const [step, setStep, refStep] = useStateAndRef(0);
  const navigate = useNavigate();

  return (
    <div
      className={
        "app-stats-container thanks-gradient-background message-container "
      }
    >
      <motion.div
        key="step-0"
        className="app-stats-content"
        initial={{ opacity: 0, y: "100%" }}
        animate={{ opacity: 1, y: "0%" }}
        exit={{ opacity: 0, y: "-100%" }}
        transition={{
          duration: 1.0,
          delay: 0.5,
          ease: [0, 0.71, 0.2, 1.01],
        }}
      >
        <TypeAnimation
          className="headline-light message-container"
          sequence={[
            200,
            "That's it for today",
            1000,
            featureText,
            2000,
            () => {
              next();
            },
          ]}
          style={{ fontSize: "2em" }}
          typeSpeed={620}
        />
      </motion.div>

      <AirbudsYearlyHeader
        closeAction={() => {
          navigate("/menu");
        }}
      />
    </div>
  );
};
